<template>
    <div class=""
        :data-component-name="$options.name"
    >
        <q-input
            v-bind="$attrs"
            :outlined="outlined"
            :dense="dense"
            :filled="filled"
            :rules="[ dateIsValid ]"
            @input="$emit('input', $event)"
            @click="$refs.qDateProxy.show()"
        >
            <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                        <q-date
                            :first-day-of-week="$generalSettings.settings.firstDayOfWeek"
                            minimal
                            v-bind="$attrs"
                            mask="YYYY-MM-DD"
                            @input="dateSet($event)"
                        >
                        </q-date>
                    </q-popup-proxy>
                </q-icon>
            </template>
        </q-input>
    </div>
</template>

<script>
    import QDate from 'quasar'
    import moment from 'moment';

    export default {
        name: "DatePicker",
        extends: QDate,
        props: {
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            }
        },
        computed:  {
        },
        methods: {
            dateIsValid(val) {
                if(!val) return
                if(!moment(val, 'YYYY-MM-DD',true).isValid() && !this.$attrs.multiple) return '* Format de date invalide'
            },
            dateSet(val) {
                this.$emit('input', val);
                if(!this.$attrs.multiple) this.$refs.qDateProxy.hide();
            }
        }
    }
</script>
